/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The dictionary type
 * @export
 */
export const DictionaryType = {
    SHIP: 'SHIP',
    PRICEMODEL: 'PRICEMODEL',
    REGION: 'REGION',
    CAMPAIGN: 'CAMPAIGN',
    CATEGORY_GROUP: 'CATEGORY_GROUP',
    GATEWAY: 'GATEWAY',
    CRUISE_ATTRIBUTE: 'CRUISE_ATTRIBUTE',
    DEPARTURE_PORT: 'DEPARTURE_PORT',
    PORT: 'PORT',
    ARRIVAL_PORT: 'ARRIVAL_PORT'
} as const;
export type DictionaryType = typeof DictionaryType[keyof typeof DictionaryType];


export function instanceOfDictionaryType(value: any): boolean {
    for (const key in DictionaryType) {
        if (Object.prototype.hasOwnProperty.call(DictionaryType, key)) {
            if (DictionaryType[key as keyof typeof DictionaryType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DictionaryTypeFromJSON(json: any): DictionaryType {
    return DictionaryTypeFromJSONTyped(json, false);
}

export function DictionaryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DictionaryType {
    return json as DictionaryType;
}

export function DictionaryTypeToJSON(value?: DictionaryType | null): any {
    return value as any;
}

export function DictionaryTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): DictionaryType {
    return value as DictionaryType;
}

